import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Button } from '@mantine/core';

import { BE_API_ONE, utils } from "../../../utils/globalVariables";

const InsertDataX = ({ stateURL, stateButtonCaption, stateButtonIsDisabled = true, stateData }) => {

    const mountedRef = React.useRef(true);

    const notificationId = React.useRef({
        error: 'insertDataX-1',
        success: 'insertDataX-2',
    })

    const [data, setData] = React.useState({
        loading: false,
    })

    const executor = () => {
        setData(d => ({ ...d, loading: true }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('data', JSON.stringify(stateData));

        axios({
            method: 'post',
            url: BE_API_ONE + '/' + stateURL,
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, loading: false }));

            if (response.data.flag_status === 'isset') {

                notifications.show({
                    id: notificationId.current.success,
                    title: utils.notification.success.caption,
                    message: 'Berhasil Simpan Data.',
                    color: utils.notification.success.color,
                    icon: utils.notification.success.icon,
                    withBorder: true,
                    autoClose: false,
                })
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, loading: false }));

            notifications.show({
                id: notificationId.current.error,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: false,
            })
        })
    }

    return (
        <Button
            loading={data.loading}
            onClick={executor}
            disabled={stateButtonIsDisabled}
        >
            {stateButtonCaption}
        </Button>
    )
}

export default InsertDataX;